export const Step1 = [
  {
    label: "What is your primary goal with mindfulness?",
    key: "primaryGoal",
    type: "multi-select",
    options: [
      "Reduce stress",

      "Sleep better",

      "Eat more mindfully",

      "Improve focus",

      "Feel more energized",

      "Enhance general well-being",

      "Increase self-compassion",
    ],
  },
  {
    label: "Why do you want to apply mindfulness in your life?",
    key: "applyReason",
    type: "multi-select",
    maxSelection: 2,
    options: [
      "I want to reduce my stress levels",

      "I want to better manage my emotions",

      "I want to improve my concentration and productivity",

      "I want to enjoy small moments in life more",

      "I want more balance between work and personal life",
    ],
  },
];

export const Step2 = [
  {
    label:
      "How much time do you have available daily for mindfulness exercises?",
    key: "durationForMindfulness",
    type: "select",
    options: [
      "3-5 minutes",

      "5-10 minutes",

      "10-15 minutes",

      "More than 15 minutes",
    ],
  },
  {
    label: "What time of day do you prefer to practice mindfulness?",
    key: "timeForMindfulness",
    type: "multi-select",
    options: ["Morning", "Afternoon", "Evening", "Variable"],
  },
  {
    label: "Would you like to receive daily reminders to practice mindfulness?",
    key: "dailyReminders",
    type: "select",
    options: ["Yes", "No"],
  },
];

export const Step3 = [
  {
    label: "How would you describe your current experience with mindfulness? ",
    key: "currentExperience",
    type: "select",
    options: [
      "I am a beginner with no prior experience",

      "I have tried it before but not regularly",

      "I practice regularly but want more structure",

      "I am advanced and want to deepen my skills",
    ],
  },
  {
    label: "Which mindfulness exercises have you tried before?",
    key: "triedBeforeExercises",
    type: "multi-select",
    options: [
      "Breathing exercises",

      "Meditation",

      "Body scans",

      "Yoga or mindful movement",

      "Gratitude exercises",

      "None of the above",
    ],
  },
  {
    label: "What did you like about these exercises?",
    key: "likedExercises",
    type: "multi-select",
    maxSelection: 2,
    options: [
      "They help me relax",

      "They improve my concentration",

      "They help me live more in the moment",

      "They reduce my stress",

      "They give me a sense of control",
      "I haven’t tried these exercises before",
    ],
  },
  {
    label: "What did you find less enjoyable or challenging?",
    key: "enjoyableChallenging",
    type: "multi-select",
    maxSelection: 2,
    options: [
      "It took too long",

      "It was difficult to calm my thoughts",

      "It felt uncomfortable or strange",

      "I didn’t see immediate benefits",

      "I found it hard to stick with",
      "I haven’t tried these exercises yet",
    ],
  },
];

export const Step4 = [
  {
    label: "How would you rate your current stress level?",
    key: "mindulnessStressLevel",
    type: "select",
    options: [
      "No stress",
      "Low Stress",
      "Medium Stress",
      "High Stress",
      "Very Stressed",
    ],
  },
  {
    label: "What causes the most stress in your life?",
    key: "moreStress",
    type: "multi-select",
    options: [
      "Work",

      "School or studies",

      "Family life",

      "Financial concerns",

      "Health",

      "Other responsibilities",
    ],
  },
  {
    label: "How is your energy level throughout the day?",
    key: "energyLevel",
    type: "select",
    options: [
      "Low (I often feel tired or drained)",
      "Moderate (I have enough energy, but it could be better)",
      "High (I usually have plenty of energy)",
    ],
  },
];

export const Step5 = [
  {
    label: "How mindful are you when eating?",
    key: "eatingMind",
    type: "select",
    options: [
      "I often eat without thinking about it",

      "Sometimes I pay attention to what I eat, but often not",

      "I am reasonably mindful of my eating habits",

      "I am very mindful and eat with full awareness",
    ],
  },
  {
    label: "What do you struggle with the most when it comes to eating?",
    key: "eatingStruggle",
    type: "multi-select",
    options: [
      "Emotional eating",

      "Frequent snacking",

      "Overeating",

      "Mindless eating (eg while watching TV or working)",

      "Choosing healthy options",
    ],
  },
];

export const Step6 = [
  {
    label: "How do you currently sleep?",
    key: "currentlySleep",
    type: "select",
    options: [
      "Poorly (I often have trouble falling or staying asleep)",

      "Moderately (My sleep is okay but could improve)",

      "Well (I usually sleep well and feel rested)",
    ],
  },
  {
    label: "What affects your sleep the most?",
    key: "effectSleep",
    type: "multi-select",
    options: [
      "Stress or overthinking",

      "Irregular sleep schedule",

      "Using screens (phone laptop etc) before bed",

      "Physical discomfort",

      "Noise or light",
    ],
  },
];

export const Step7 = [
  {
    label: "How is your concentration during the day?",
    key: "dayConcentration",
    type: "select",
    options: [
      "Poor (I often struggle to focus)",

      "Moderate (My focus is okay but could improve)",

      "Good (I can usually concentrate well)",
    ],
  },
  {
    label: "What are the biggest distractions in your daily life?",
    key: "lifeDistraction",
    type: "multi-select",
    options: [
      "Work or school",

      "Social media",

      "Family responsibilities",

      "My own thoughts or emotions",

      "Other distractions",
    ],
  },
];

export const Step8 = [
  {
    label: "Which types of mindfulness exercises appeal to you the most?",
    key: "appealingExercise",
    type: "multi-select",
    options: [
      "Breathing exercises",

      "Short meditations",

      "Gratitude exercises",

      "Reflection questions",
      "Body scans",

      "Yoga or stretch routines",
    ],
  },
  {
    label: "How would you like to receive your daily or weekly advice?",
    key: "recieveNotif",
    type: "select",
    options: [
      "Via text",

      "Via email",

      "Via a notification in the app or website",
    ],
  },
];

export const mindfulnessStepsData = [
  {
    label: "What is your primary goal with mindfulness?",
    key: "primaryGoal",
    type: "multi-select",
    options: [
      "Reduce stress",

      "Sleep better",

      "Eat more mindfully",

      "Improve focus",

      "Feel more energized",

      "Enhance general well-being",

      "Increase self-compassion",
    ],
  },
  {
    label: "Why do you want to apply mindfulness in your life?",
    key: "applyReason",
    type: "multi-select",
    maxSelection: 2,
    options: [
      "I want to reduce my stress levels",

      "I want to better manage my emotions",

      "I want to improve my concentration and productivity",

      "I want to enjoy small moments in life more",

      "I want more balance between work and personal life",
    ],
  },
  {
    label:
      "How much time do you have available daily for mindfulness exercises?",
    key: "durationForMindfulness",
    type: "select",
    options: [
      "3-5 minutes",

      "5-10 minutes",

      "10-15 minutes",

      "More than 15 minutes",
    ],
  },
  {
    label: "What time of day do you prefer to practice mindfulness?",
    key: "timeForMindfulness",
    type: "multi-select",
    options: ["Morning", "Afternoon", "Evening", "Variable"],
  },
  {
    label: "Would you like to receive daily reminders to practice mindfulness?",
    key: "dailyReminders",
    type: "select",
    options: ["Yes", "No"],
  },
  {
    label: "How would you describe your current experience with mindfulness? ",
    key: "currentExperience",
    type: "select",
    options: [
      "I am a beginner with no prior experience",

      "I have tried it before but not regularly",

      "I practice regularly but want more structure",

      "I am advanced and want to deepen my skills",
    ],
  },
  {
    label: "Which mindfulness exercises have you tried before?",
    key: "triedBeforeExercises",
    type: "multi-select",
    options: [
      "Breathing exercises",

      "Meditation",

      "Body scans",

      "Yoga or mindful movement",

      "Gratitude exercises",

      "None of the above",
    ],
  },
  {
    label: "What did you like about these exercises?",
    key: "likedExercises",
    type: "multi-select",
    maxSelection: 2,
    options: [
      "They help me relax",

      "They improve my concentration",

      "They help me live more in the moment",

      "They reduce my stress",

      "They give me a sense of control",
      "I haven’t tried these exercises before",
    ],
  },
  {
    label: "What did you find less enjoyable or challenging?",
    key: "enjoyableChallenging",
    type: "multi-select",
    maxSelection: 2,
    options: [
      "It took too long",

      "It was difficult to calm my thoughts",

      "It felt uncomfortable or strange",

      "I didn’t see immediate benefits",

      "I found it hard to stick with",
      "I haven’t tried these exercises yet",
    ],
  },
  {
    label: "How would you rate your current stress level?",
    key: "mindulnessStressLevel",
    type: "select",
    options: [
      "No stress",
      "Low Stress",
      "Medium Stress",
      "High Stress",
      "Very Stressed",
    ],
  },
  {
    label: "What causes the most stress in your life?",
    key: "moreStress",
    type: "multi-select",
    options: [
      "Work",

      "School or studies",

      "Family life",

      "Financial concerns",

      "Health",

      "Other responsibilities",
    ],
  },
  {
    label: "How is your energy level throughout the day?",
    key: "energyLevel",
    type: "select",
     options: [
      "Low (I often feel tired or drained)",
      "Moderate (I have enough energy, but it could be better)",
      "High (I usually have plenty of energy)",
    ],
  },
  {
    label: "How mindful are you when eating?",
    key: "eatingMind",
    type: "select",
    options: [
      "I often eat without thinking about it",

      "Sometimes I pay attention to what I eat, but often not",

      "I am reasonably mindful of my eating habits",

      "I am very mindful and eat with full awareness",
    ],
  },
  {
    label: "What do you struggle with the most when it comes to eating?",
    key: "eatingStruggle",
    type: "multi-select",
    options: [
      "Emotional eating",

      "Frequent snacking",

      "Overeating",

      "Mindless eating (eg while watching TV or working)",

      "Choosing healthy options",
    ],
  },
  {
    label: "How do you currently sleep?",
    key: "currentlySleep",
    type: "select",
    options: [
      "Poorly (I often have trouble falling or staying asleep)",

      "Moderately (My sleep is okay but could improve)",

      "Well (I usually sleep well and feel rested)",
    ],
  },
  {
    label: "What affects your sleep the most?",
    key: "effectSleep",
    type: "multi-select",
    options: [
      "Stress or overthinking",

      "Irregular sleep schedule",

      "Using screens (phone laptop etc) before bed",

      "Physical discomfort",

      "Noise or light",
    ],
  },
  {
    label: "How is your concentration during the day?",
    key: "dayConcentration",
    type: "select",
    options: [
      "Poor (I often struggle to focus)",

      "Moderate (My focus is okay but could improve)",

      "Good (I can usually concentrate well)",
    ],
  },
  {
    label: "What are the biggest distractions in your daily life?",
    key: "lifeDistraction",
    type: "multi-select",
    options: [
      "Work or school",

      "Social media",

      "Family responsibilities",

      "My own thoughts or emotions",

      "Other distractions",
    ],
  },
  {
    label: "Which types of mindfulness exercises appeal to you the most?",
    key: "appealingExercise",
    type: "multi-select",
    options: [
      "Breathing exercises",

      "Short meditations",

      "Gratitude exercises",

      "Reflection questions",
      "Body scans",

      "Yoga or stretch routines",
    ],
  },
  {
    label: "How would you like to receive your daily or weekly advice?",
    key: "recieveNotif",
    type: "select",
    options: [
      "Via text",

      "Via email",

      "Via a notification in the app or website",
    ],
  },
];

export const initialSleepData = {
  primaryGoal: [],
  applyReason: [],
  durationForMindfulness: "",
  timeForMindfulness: [],
  dailyReminders: "",
  currentExperience: "",
  triedBeforeExercises: [],
  likedExercises: [],
  enjoyableChallenging: [],
  mindulnessStressLevel: "",
  moreStress: [],
  energyLevel: "",
  eatingMind: "",
  eatingStruggle: [],
  currentlySleep: "",
  effectSleep: [],
  dayConcentration: "",
  lifeDistraction: [],
  appealingExercise: [],
  recieveNotif: "",
};
